/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, CardContent, Checkbox, Collapse, Dialog, FormControl, FormControlLabel, IconButton, Stack, TextField, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { ExpandMore } from '@mui/icons-material';
import { Button } from 'react-bootstrap';
import { getQuestionTags, getCodingQuestionByID, getCodingQuestionLanguages, getCodingQuestionReturnTypes, getQuestionLevels, postCreateCodingQuestion, postUpdateCodingQuestion, resetCodingQuestionById } from '../../Redux/ActionCreators/testLibraryAction';
import JoditEditor from 'jodit-react';
import { returnErrors } from '../../Redux/ActionCreators/errorAction';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { getSkills, getSkillTopics } from '../../Redux/ActionCreators/myTestsAction';


const UI_STRINGS = {
    "OUTPUT": 'output',
    "TIME": 'time',
    "DIFFICULTY": 'difficulty',
}

const save_button_style = {
    backgroundColor: 'var(--button-color)',
    color: '#fff',
    borderRadius: '12px',
    height: 48,
    border: 'none',
    fontSize: 14,
    padding: '10px 30px',
    minWidth: 150,
    marginBottom: 50,
}

const joditConfig = {
  toolbarInlineForSelection: true,
  toolbar: true,
  readonly: false,
  statusbar: false,
  showCharsCounter: false,
  showWordsCounter: false,
  height: 150,
  askBeforePasteFromWord: false,
  askBeforePasteHTML: false,
  defaultActionOnPaste: "insert_clear_html",
  defaultActionOnPasteFromWord: "insert_as_html",
  enableDragAndDropFileToEditor: true,
  removeButtons: ["eraser", "fullsize"],
};

const CreateCodingQuestion = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const isEmbedded = props?.embedded || props?.fromCreateQuestion || false;
    const currentEditMode = isEmbedded ? props?.editMode : location?.state?.edit;
    const currentViewMode = isEmbedded ? props?.viewMode : location?.state?.view;
    const currentDetail = isEmbedded ? props?.existingDetail : location?.state?.detail;
    const currentType = isEmbedded ? props?.questionTypeID : Number(location?.state?.questionTypeID);

    const details = JSON.parse(localStorage.getItem("profileDetails"));
    const [funcName, setFuncName] = useState('');
    const [loading, setLoading] = useState(false);
    const descriptionEditorRef = useRef(null);
    const { questionLevel, qTags, codingQuestionReturnTypesOptions, codingQuestionLanguagesOptions, codingQuestionByIdResponse, loadingCodingQuestionById } = useSelector(state => state.testLibrary);
    const { skills, topics } = useSelector((state) => state.myTests);

    const [questionTitle, setQuestionTitle] = useState('');
    const [questionDescription, setQuestionDescription] = useState('');
    const [questionDescriptionError, setQuestionDescriptionError] = useState('');

    const [programmingLanguages, setProgrammingLanguages] = useState([]);
    const [tags, setTags] = useState([]);


    const [questionWeightage, setQuestionWeightage] = useState(20);

    const [timeDuration, setTimeDuration] = useState(10);

    const [selectOutput, setSelectOutput] = useState(1);

    const [selectDifficulty, setSelectDifficulty] = useState(1);

    const [inputs, setInputs] = useState([{ inputName: 'n', inputTypeId: 1 }]);

    const [expanded, setExpanded] = useState(true);

    const [testCases, setTestCases] = useState([
        { isDefault: 1, output: '', inputs: [{ input: '' }] },
        { isDefault: 0, output: '', inputs: [{ input: '' }] }
    ]);

    const [sampleSolution, setSampleSolution] = useState("");
    const [configuration, setConfiguration] = useState("");
    const [dbTestCases, setDbTestCases] = useState([
        { sqlQuery: "", isSample: false },
    ]);
    const [selectedKnowledgeArea, setSelectedKnowledgeArea] = useState(null);
    const [selectedTopic, setSelectedTopic] = useState(null);

    useEffect(() => {
        dispatch(getQuestionTags())
    }, [])

    useEffect(() => {
        if (loadingCodingQuestionById) {
            return;
        }

        if (codingQuestionByIdResponse) {
            const { question } = codingQuestionByIdResponse;
            if (!question) return;
            setQuestionTitle(question?.name || '');
            setQuestionDescription(question?.description || '');
            setProgrammingLanguages(question?.languages?.map(el => [{ label: el.displayLanguage, value: el.codingLanguageId }][0]));
            setQuestionWeightage(question?.score || 0);
            setTimeDuration(question?.duration || 0);
            setSelectOutput(question?.outputReturnTypeId || 0);
            setSelectDifficulty(question?.difficultyLevelId || 1);
            setInputs(question?.inputs);
            setTags(question?.tags?.map(el => [{ label: el, value: el }][0]));
            setFuncName(question?.functionName || '');
            // question?.testCases?.forEach(testCase => {
            //     testCase.inputs.sort((a, b) => a.id - b.id);
            // })
            // setTestCases(question?.testCases);
            if (question?.questionTypeID === 12 && question?.data) {
                try {
                    const parsedData = JSON.parse(question.data);
                    setSampleSolution(parsedData?.Solution || "");
                    setConfiguration(parsedData?.Configuration || "");
                    setDbTestCases(
                    parsedData?.TestCases?.map(tc => ({
                        sqlQuery: tc?.SqlQuery || "",
                        isSample: tc?.IsSample || false,
                    })) || [{ sqlQuery: "", isSample: false }]
                    );
                } catch (err) {
                    console.error("Error parsing database question data:", err);
                }
            } else {
                question?.testCases?.forEach(tc => {
                    tc.inputs?.sort((a, b) => a.id - b.id);
                });
                setTestCases(question?.testCases || []);
            }

            if (question?.skillId) {
                setSelectedKnowledgeArea({
                    label: question?.skillName,
                    value: question?.skillId,
                });
            }
            if (question?.skillTopicId) {
                setSelectedTopic({
                    label: question?.skillTopicName,
                    value: question?.skillTopicId,
                });
            }
        }
        if (!location.state.edit) {
            resetStates();
        }
    }, [codingQuestionByIdResponse])

    const handleExpandClick = () => {
        setExpanded((expanded) => !expanded);
    };

    const handleSelectChange = (select_name, event) => {
        if (select_name === UI_STRINGS.OUTPUT) {
            setSelectOutput(event?.target?.value);
        }
        if (select_name === UI_STRINGS.DIFFICULTY) {
            setSelectDifficulty(event?.target?.value);
        }
    }
    const selectLanguage = async (e) => {
        if (e.some(el => el.value === 'all')) {
            await setProgrammingLanguages(codingQuestionLanguagesOptions?.map(el => [{ label: el.displayLanguage, value: el.id }][0]));
        } else {
            await setProgrammingLanguages(e);
        }
    }

    const handleTags = (e) => {
        console.log(e)
        setTags(e)
    }

    const handleInputs = (index, key, event) => {
        const value = event?.target?.value;
        let inputs_copy = [...inputs];
        inputs_copy[index][key] = value;
        setInputs(inputs_copy);
    };

    // const handleTestCase = (case_index, input_index, key, event) => {
    //     const value = event?.target?.value;
    //     let testCases_copy = [...testCases];
    //     testCases_copy[case_index].inputs[input_index][key] = value;
    //     setTestCases(testCases_copy);
    // };
    const handleTestCase = (case_index, input_index, key, event) => {
        const value = event?.target?.value;
        let testCases_copy = [...testCases];

        // Ensure inputs array has an element at input_index
        if (!testCases_copy[case_index].inputs[input_index]) {
            testCases_copy[case_index].inputs.push({ input: '' });
        }

        testCases_copy[case_index].inputs[input_index][key] = value;
        setTestCases(testCases_copy);
    }

    const defaultTestCaseChangeHandler = (case_index, event) => {
        let testCases_copy = [...testCases];
        testCases_copy?.forEach((test_case, index) => {
            if (case_index === index) {
                test_case.isDefault = 1;
            } else {
                test_case.isDefault = 0;
            }
        })
        setTestCases(testCases_copy);
    };

    const testCaseOutputChangeHandler = (case_index, event) => {
        const value = event?.target?.value;
        let testCases_copy = [...testCases];
        testCases_copy[case_index].output = value;
        setTestCases(testCases_copy);
    };

    const deleteInputHandler = (index) => {
        let inputs_copy = [...inputs];
        inputs_copy.splice(index, 1);
        setInputs(inputs_copy);
    }

    const validateInputOnBlur = (input, index) => {
        if (!input?.inputName) {
            deleteInputHandler(index);
        };
    }

    const validateForm = () => {

        if (currentType === 12) {
            if (!questionTitle) returnErrors(dispatch, "Question name is required!", 500);
            else if (!questionDescription) returnErrors(dispatch, "Question description is required!", 500);
            else if (!configuration) returnErrors(dispatch, "Configuration is required!", 500);
            return true;
        }

        if (!questionTitle) {
            // setQuestionTitleError('Question name required!');
            returnErrors(dispatch, 'Question name is required!', 500);
            return false;
        }
        else if (!questionDescription) {
            returnErrors(dispatch, ('Question description is required!'), 500);
            return false;
        }
        else if (!funcName) {
            returnErrors(dispatch, ('Function Name is required!'), 500);
            return false;
        }
        else if (!selectOutput) {
            returnErrors(dispatch, ('Question output is required!'), 500);
            return false;
        }
        else if (!timeDuration) {
            returnErrors(dispatch, ('Question duration is required!'), 500);
            return false;
        }
        else if (!selectDifficulty) {
            returnErrors(dispatch, ('Question difficulty is required!'), 500);
            return false;
        }
        else if (!questionWeightage) {
            returnErrors(dispatch, ('Question score is required!'), 500);
            return false;
        }
        else if (programmingLanguages?.length === 0) {
            returnErrors(dispatch, ('Atleast 1 programming is requires!'), 500);
            return false;
        }
        else if (tags?.length === 0) {
            returnErrors(dispatch, ('Atleast 1 tag is requires!'), 500);
            return false;
        }
        else if (inputs?.length === 0) {
            returnErrors(dispatch, ('Atleast 1 input is requires!'), 500);
            return false;
        }
        else if (testCases?.length === 0) {
            returnErrors(dispatch, ('Atleast 2 test cases is requires!'), 500);
            return false;
        } 
        else if (!selectedKnowledgeArea) {
            returnErrors(dispatch, "Please select a Knowledge Area!", 500);
            return false;
        }
        else if (!selectedTopic) {
            returnErrors(dispatch, "Please select a Topic!", 500);
            return false;
        }

        //* checking if Input have empty fields
        const hasInvalidInput = inputs.some((input) => input?.inputName === '');
        if (hasInvalidInput) {
            returnErrors(dispatch, ("Input name can't be empty"), 500);
            return false;
        }


        //* checking if test-cases have empty fields
        const isEmptyTestCase = testCases?.some((testCase) =>
            testCase?.output === '' || testCase?.inputs?.every((input_) => input_?.input === '')
        );
        if (isEmptyTestCase) {
            returnErrors(dispatch, ("Test cases fields can't be empty"), 500);
            return false;
        }

        return true;

    }

    const stripHTML = (htmlString) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlString;
        return tempDiv.textContent || tempDiv.innerText || "";
    };

    const questionSaveHandler = async () => {
        await setLoading(true);
        const is_formValid = validateForm();
        if (is_formValid) {
            let request_data;
            if (currentType === 12) {
                request_data = {
                    tenantId: parseInt(details?.tenentId),
                    questionTypeID: currentType,
                    name: questionTitle,
                    description: questionDescription,
                    outputReturnTypeId: 0,
                    duration: timeDuration,
                    difficultyLevelId: selectDifficulty,
                    weightage: questionWeightage,
                    functionName: "",
                    inputs: [],
                    testCases: [],
                    tags: tags.map(el => el.value),
                    languages: programmingLanguages.map(el => ({ codingLanguageId: el.value })),
                    data: JSON.stringify({
                        Solution: stripHTML(sampleSolution),
                        Configuration: configuration,
                        TestCases: dbTestCases.map(tc => ({
                            IsSample: tc.isSample,
                            SqlQuery: stripHTML(tc.sqlQuery),
                        })),
                    }),
                    skillId: selectedKnowledgeArea?.value || 0,
                    skillTopicId: selectedTopic?.value || 0,
                    skillName: selectedKnowledgeArea?.label || "",
                    skillTopicName: selectedTopic?.label || "",
                }
            } else {
                request_data = {
                    tenantId: parseInt(details?.tenentId),
                    questionTypeID: currentType,
                    name: questionTitle,
                    description: questionDescription,
                    outputReturnTypeId: selectOutput,
                    duration: timeDuration,
                    difficultyLevelId: selectDifficulty,
                    weightage: questionWeightage,
                    languages: programmingLanguages.map(el => [{ codingLanguageId: el.value }][0]),
                    inputs: inputs,
                    tags: tags.map(el => el.value),
                    testCases: testCases,
                    functionName: funcName,
                    addFromList: props.addFromList ? true : null,
                    skillId: selectedKnowledgeArea?.value || 0,
                    skillTopicId: selectedTopic?.value || 0,
                    skillName: selectedKnowledgeArea?.label || "",
                    skillTopicName: selectedTopic?.label || "",
                }
            }
            if (location?.state?.edit) {
                request_data.id = location?.state?.detail?.id;
                const response = await dispatch(postUpdateCodingQuestion({ ...request_data, id: location.state.detail?.id }));
                if (response.type === 'UPDATE_CODING_QUESTION') {
                    navigate(-1)
                }
            }else {
                const response = await dispatch(postCreateCodingQuestion(request_data));
                if (response?.type === 'CREATE_CODING_QUESTION') {
                    props.addFromList ? props.goBack() : navigate(-1)
                }
            }
            await setLoading(false);
        }
        await setLoading(false);
    }
    const resetStates = () => {
        setQuestionTitle('');
        setQuestionDescription('');
        setProgrammingLanguages([]);
        setQuestionWeightage(20);
        setTimeDuration(10);
        setSelectOutput(1);
        setSelectDifficulty(1);
        setTags([])
        setInputs([{ inputName: 'n', inputTypeId: 1 }]);
        setTestCases([
            { isDefault: 1, output: '', inputs: [{ input: '' }] },
            { isDefault: 0, output: '', inputs: [{ input: '' }] }
        ]);
    }


    useEffect(() => {
        const fetchQuestion = async () => {
            if (location?.state?.detail?.id) {
                await dispatch(resetCodingQuestionById());
                setTimeout(async () => {
                    await dispatch(getCodingQuestionByID(location.state.detail.id));
                }, 0);
            }
        };
        fetchQuestion();

        dispatch(getCodingQuestionLanguages());
        dispatch(getCodingQuestionReturnTypes());
        dispatch(getQuestionLevels());
     }, []);

    useEffect(() => {
        if (currentEditMode && currentDetail?.skillId) {
            setLoading(true);
            setSelectedKnowledgeArea({
            label: currentDetail?.skillName,
            value: currentDetail?.skillId,
            });
            setSelectedTopic({
            label: currentDetail?.skillTopicName,
            value: currentDetail?.skillTopicId,
            });
            dispatch(getSkillTopics(2, currentDetail?.skillId));
            setLoading(false);
        }
    }, [currentEditMode, currentDetail]);

    const handleKnowledgeAreaChange = async (selectedArea) => {
        setSelectedKnowledgeArea(selectedArea);
        setSelectedTopic(null);

        if (selectedArea?.value) {
            const details = JSON.parse(localStorage.getItem("profileDetails"));
            setLoading(true);
            const response =
            details?.tenentId === "-1" && details?.roleId === "1"
                ? await dispatch(getSkillTopics(selectedArea.value))
                : await dispatch(getSkillTopics(0, selectedArea.value));

            if (response?.payload) {
            console.log("Topics fetched for Knowledge Area:", response?.payload);
            }
            setLoading(false);
        }
        };


    return (<div>

        <Dialog
            className="screen-loader"
            open={loading}
            onClose={() => {}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
                Loading ...
        </Dialog>

        <div className={isEmbedded ? "": "bg-white rounded m-3 px-5 py-3 create-question-main"}>
            {!isEmbedded && (
                <>
                    <div>
                        <div className="d-flex">
                            {/* <img src='/images/back.svg' alt='' className='cursor-pointer' onClick={() => window.location.pathname.includes('test-library') ? props.goBack() : navigate(-1)} /> */}
                            <img src='/images/back.svg' alt='' className='cursor-pointer' onClick={props?.onClose || (() => navigate(-1))} />&nbsp;&nbsp;
                            <h1 className="maintxt"> {location?.state?.view ? ('View Question') : location?.state?.edit ? ('Edit Question') : ('Create Question')}</h1>
                        </div>
                    </div>
                    <br />
                </>
            )}

            <div className='row mt-4'>
                <div className='col-md-6 col-12'>
                    <Stack spacing={2}>
                        <div><label className="labeltext px-0">Knowledge Area*</label></div>
                        <div className='mt-2'>
                            <Select
                                isClearable
                                placeholder="Select Knowledge Area"
                                options={
                                    skills?.map(el => ({
                                    label: el.label || el.knowledgeAreaName || el.skillName,
                                    value: el.value || el.knowledgeAreaId || el.skillId
                                    })) || []
                                }
                                value={selectedKnowledgeArea}
                                onChange={(e) => handleKnowledgeAreaChange(e)}
                            />
                        </div>
                    </Stack>
                </div>
                <div className='col-md-6 col-12'>
                    <Stack spacing={2}>
                        <div><label className="labeltext px-0">Topics*</label></div>
                        <div className='mt-2'>
                            <Select
                                isClearable
                                placeholder="Select Topic"
                                options={
                                    topics?.map(el => ({
                                    label: el.label || el.topicName || el.skillTopicName,
                                    value: el.value || el.topicId || el.skillTopicId
                                    })) || []
                                }
                                value={selectedTopic}
                                onChange={(e) => setSelectedTopic(e)}
                            />
                        </div>
                    </Stack>
                </div>
            </div>

            <Stack spacing={5}>
                {/* <TextField fullWidth label={<b>Question Name</b>} id="fullWidth" /> */}
                <div className='form-group mt-3'>
                    <label className="labeltext px-0">Question Name*</label>
                    <input type='text' required value={questionTitle} maxLength={200} className='form-control mt-1' onChange={(e) => { setQuestionTitle(e.target.value) }} />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <label className="labeltext px-0">Question Description</label>
                    <div className="row mb-2">
                        <div className="col-12">
                            <JoditEditor
                                config={{
                                    ...joditConfig, 
                                    placeholder: questionDescription ? '' : 'Start writing...',
                                }}
                                ref={descriptionEditorRef}
                                value={questionDescription}
                                // onChange={newContent => {
                                //     setQuestionDescription(newContent)
                                //     setQuestionDescriptionError('')
                                // }}
                                onBlur={(newContent) => {
                                    setQuestionDescription(newContent);
                                    setQuestionDescriptionError('');
                                }}
                            />
                            {questionDescriptionError && <small style={{ color: 'red' }}>{questionDescriptionError}</small>}
                        </div>
                    </div>
                </div>
                {currentType !== 12 && (
                    <Stack spacing={2}>
                        <div><label className="labeltext px-0">Function Name*</label></div>
                        <div className='mt-2'>
                            <input type='text' value={funcName} className='form-control mt-2' 
                            onChange={(e) => {
                                const noSpaces = e.target.value.replace(/\s+/g, '');
                                setFuncName(noSpaces);
                            }} 
                        />
                        </div>
                    </Stack>
                )}

                <Stack spacing={2}>
                    <div><label className="labeltext px-0">{currentType === 12 ? "Database Languages" : "Programming Languages"}*</label></div>
                    <div className='mt-2'>
                        <Select
                            isMulti={currentType === 7}
                            placeholder='Select Languages'
                            options={
                                codingQuestionLanguagesOptions
                                ?.filter(lang => lang.category?.id === (currentType === 12 ? 2 : 1))
                                ?.map(el => ({ label: el.displayLanguage, value: el.id })) || []
                            }
                            value={programmingLanguages}
                            // onChange={(e) => selectLanguage(e)}
                            onChange={(e) => {
                                if (currentType === 12) {
                                setProgrammingLanguages(e ? [e] : []);
                                } else {
                                setProgrammingLanguages(e || []);
                                }
                            }}
                            />
                    </div>
                </Stack>
                <Stack spacing={2}>
                    <div><label className="labeltext px-0">Tags*</label></div>
                    <div className='mt-2'>
                        <CreatableSelect
                            options={qTags}
                            isMulti
                            value={tags}
                            placeholder='Enter tags'
                            onChange={(e) => handleTags(e)} />
                    </div>
                </Stack>
            </Stack>
            <br />

            <Box sx={{ flexGrow: 2, display: 'flex', alignItems: 'baseline', gap: 1, }}>
                <FormControl sx={{ m: 1, width: 250 }} variant="outlined" size="small">
                    <div>
                        <label className="labeltext px-0">Time* (Minutes)</label>
                        <input type='number' value={timeDuration} min={1} className='form-control mt-2' style={{ padding: 8 }} 
                        // onChange={(e) => { setTimeDuration(e.target.value) }} 
                            onChange={(e) => {
                                const value = Number(e.target.value);

                                if (value < 1) {
                                setTimeDuration(1);
                                } else {
                                setTimeDuration(value);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "-" || e.key === "e") {
                                e.preventDefault();
                                }
                            }}
                        />
                    </div>
                </FormControl>
                <FormControl sx={{ m: 1, width: 250 }} variant="outlined" size="small">
                    <div>
                        <label className="labeltext px-0">Score* (Marks)</label>
                        <input type='number' value={questionWeightage} min={1} className='form-control mt-2' style={{ padding: 8 }} 
                        // onChange={(e) => { setQuestionWeightage(e.target.value) }}
                            onChange={(e) => {
                                const value = Number(e.target.value);

                                if (value < 1) {
                                setQuestionWeightage(1);
                                } else {
                                setQuestionWeightage(value);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "-" || e.key === "e") {
                                e.preventDefault();
                                }
                            }}
                         />
                    </div>
                </FormControl>
            </Box><br />
            <Box sx={{ flexGrow: 2, display: 'flex', alignItems: 'baseline', gap: 1 }}>
                {currentType !== 12 && (
                    <FormControl sx={{ m: 1, width: 250 }} variant="outlined" size="small">
                        <label className="labeltext px-0" id="output-simple-select-label">Output* (Return type)</label>
                        <div className='mt-2'>
                            <select
                                defaultValue={0}
                                labelId="output-simple-select-label"
                                id="output-simple-select"
                                className='form-control'
                                value={selectOutput}
                                onChange={(event) => handleSelectChange(UI_STRINGS.OUTPUT, event)}
                            >
                                {codingQuestionReturnTypesOptions?.returnTypes?.map((option, i) => {
                                    return (
                                        <option key={i} value={option?.id}>{option?.retrunType}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </FormControl>
                )}
                <FormControl sx={{ m: 1, width: 250 }} variant="outlined" size="small">
                    <div><label className="labeltext px-0" id="level-simple-select-label">Difficulty* (Level)</label></div>
                    <div className='mt-2'>
                        <select
                            defaultValue={0}
                            labelId="level-simple-select-label"
                            id="level-simple-select"
                            className='form-control'
                            value={selectDifficulty}
                            onChange={(event) => handleSelectChange(UI_STRINGS.DIFFICULTY, event)}
                        >
                            {questionLevel?.map((option, i) => {
                                return (
                                    <option key={i} value={option?.questionLevelID}>{option?.questionLevelName}</option>
                                )
                            })}
                        </select>
                    </div>
                </FormControl>
            </Box>
            <br />

            {currentType !== 12 && (
                <Box sx={{ flexGrow: 1 }}>
                    <div className='form-group mt-3'>
                        <label className="labeltext px-0">Inputs*</label>
                        {inputs?.map((input, i) => {
                            return (
                                <Box key={i}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1
                                    }}
                                >  <FormControl sx={{ m: 1, width: 250 }} variant="outlined" size="small">
                                        <TextField id="input-basic" label="Input name" required variant="outlined" size="small" value={input?.inputName} onBlur={() => validateInputOnBlur(input, i)} onChange={(event) => handleInputs(i, 'inputName', event)} />
                                    </FormControl>
                                    <FormControl required sx={{ m: 1, minWidth: 250 }} variant="outlined" size="small">
                                        <select
                                            placeholder=''
                                            defaultValue={1}
                                            className='select-input form-control'
                                            labelId="input-type-simple-select-label"
                                            label="Input type"
                                            id="input-type-simple-select"
                                            value={input?.inputTypeId}
                                            onChange={(event) => handleInputs(i, 'inputTypeId', event)}
                                        >
                                            {codingQuestionReturnTypesOptions?.returnTypes?.map((option, i) => {
                                                return (
                                                    <option key={i} value={option?.id}>{option?.retrunType}</option>
                                                )
                                            })}

                                        </select>
                                    </FormControl>
                                    {i !== 0 && <IconButton onClick={() => deleteInputHandler(i)} aria-label="delete">
                                        <DeleteIcon />
                                    </IconButton>}
                                </Box>
                            )
                        })}
                        <Button style={{ color: '#009199', fontWeight: 'bold' }} onClick={() => setInputs([...inputs, { inputName: '', inputTypeId: 1 }])} variant="outlined">Add more input</Button>
                    </div>
                </Box>
            )}
        </div>

        {currentType === 12 ? (
        <div className={isEmbedded ? "": "bg-white rounded m-3 px-5 py-3 create-question-main"}>
            <Stack spacing={4}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <label className="labeltext px-0">Sample Solution</label>
                <div className="row mb-2">
                    <div className="col-12">
                        <JoditEditor
                            value={sampleSolution}
                            config={{...joditConfig, placeholder: sampleSolution ? '' : 'Start writing...'}}
                            // onChange={content => setSampleSolution(content)}
                            onBlur={content => setSampleSolution(content)}
                        />
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <label className="labeltext px-0">Configuration*</label>
                <div className="row mb-2">
                    <div className="col-12">
                        <JoditEditor
                            value={configuration}
                            config={{...joditConfig, placeholder: configuration ? '' : 'Start writing...'}}
                            // onChange={content => setConfiguration(content)}
                            onBlur={content => setConfiguration(content)}
                        />
                    </div>
                </div>
            </div>
            <div>
                <label className="labeltext px-0">Test Cases*</label>
                {dbTestCases.map((tc, idx) => (
                <Box
                    key={idx}
                    sx={{
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    padding: 2,
                    marginBottom: 2,
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <Typography variant="subtitle1">Test Case {idx + 1}</Typography>
                        <div className="row mb-2">
                            <div className="col-12">
                                <JoditEditor
                                    value={tc.sqlQuery}
                                    config={{...joditConfig, placeholder: tc.sqlQuery ? '' : 'Start writing...'}}
                                    // onChange={(val) => {
                                    //     const updated = [...dbTestCases];
                                    //     updated[idx].sqlQuery = val;
                                    //     setDbTestCases(updated);
                                    // }}
                                    onBlur={(val) => {
                                        const updated = [...dbTestCases];
                                        updated[idx].sqlQuery = val;
                                        setDbTestCases(updated);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={tc.isSample}
                                onChange={(e) => {
                                    const updated = dbTestCases.map((test, i) => ({
                                    ...test,
                                    isSample: i === idx ? e.target.checked : false,
                                    }));
                                    setDbTestCases(updated);
                                }}
                            />
                        }
                        label="Is sample testcase?"
                    />
                    {idx > 0 && (
                    <IconButton
                        onClick={() => {
                        const updated = [...dbTestCases];
                        updated.splice(idx, 1);
                        setDbTestCases(updated);
                        }}
                    >
                        <DeleteIcon />
                    </IconButton>
                    )}
                </Box>
                ))}
                <Button style={{ color: "#009199", fontWeight: "bold" }} onClick={() =>setDbTestCases([...dbTestCases,{ sqlQuery: "", isSample: false },])} variant="outlined">Add more test cases</Button>
            </div>
            </Stack>
        </div>
        ) : (
        <div className={isEmbedded ? "": "bg-white rounded m-3 px-5 py-3 create-question-main"}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                }}
                onClick={handleExpandClick}
            >
                <ExpandMore
                    expand={expanded?.toString()}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show test cases"
                > <ExpandMoreIcon /></ExpandMore>

                <h3 className='text-start' style={{color:'black'}}>Test Cases*</h3>
            </Box>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                    {testCases?.map((testCase, index) => {
                        return (
                            <Box key={index}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 2,
                                    gap: 2,
                                    bgcolor: 'background.paper',
                                    padding: 2,
                                    marginBlock: 1
                                }}
                            >
                                <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'space-between' }}>
                                    <h6 className='text-start'>'Test case {index + 1}</h6>
                                    <div>
                                        {index > 1 && <IconButton onClick={() => {
                                            let testCases_copy = [...testCases];
                                            testCases_copy.splice(index, 1);
                                            setTestCases(testCases_copy);
                                        }
                                        } aria-label="delete">
                                            <DeleteIcon />
                                        </IconButton>}
                                    </div>
                                </Box>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 2,
                                    flexWrap: 'wrap'
                                }}
                                >
                                    {inputs?.map((input_, i) => {
                                        return (
                                            <Box key={i}
                                                sx={{
                                                    display: 'flex',
                                                    gap: 2,
                                                    alignItems: 'end'
                                                }}
                                            >
                                                <FormControl sx={{ m: 1, minWidth: 150 }} variant="outlined" size="small">
                                                    <Typography>
                                                        Input name {i + 1}  : {input_?.inputName}
                                                    </Typography>
                                                </FormControl>
                                                <FormControl sx={{ m: 1, width: 250, mr: 10 }} variant="outlined" size="small">
                                                    <TextField id="input-basic" type="text" required variant="outlined" size="small" value={testCase?.inputs[i]?.input} onChange={(event) => handleTestCase(index, i, 'input', event)} />
                                                </FormControl>
                                            </Box>
                                        )
                                    })}
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 2,
                                        alignItems: 'end'
                                    }}
                                >
                                    <FormControl sx={{ m: 1, width: 150 }} variant="outlined" size="small">
                                        <Typography>
                                            Output
                                        </Typography>
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 250 }} variant="outlined" size="small">
                                        <TextField id="input-basic" required variant="outlined" size="small" value={testCase?.output} onChange={(event) => testCaseOutputChangeHandler(index, event)} />
                                    </FormControl>
                                </Box>
                                <FormControlLabel control={<Checkbox size="small" checked={testCase?.isDefault ? true : false} onChange={(event) => defaultTestCaseChangeHandler(index, event)} />} label="Default" />
                            </Box>
                        )
                    })}

                </CardContent>
            </Collapse>
            {expanded && <Button style={{ color: '#009199', fontWeight: 'bold' }} onClick={() => setTestCases([...testCases, { isDefault: 0, inputs: [{ input: '' }] }])} variant="outlined">Add more test cases</Button>}
        </div>
        )}
        
        {!location?.state?.view && <div style={{ textAlign: 'start', marginLeft:'16px' }}> <button style={save_button_style} disabled={loading} onClick={() => questionSaveHandler()}>Save</button></div>}
        {((location?.state?.view) || (location?.state?.edit)) && <Dialog
            className='screen-loader'
            open={loadingCodingQuestionById}
            onClose={() => { }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            Loading ...
        </Dialog>}
    </div>)
}

export default CreateCodingQuestion